import { ContentfulClientApi, EntryCollection } from 'contentful';
import { Domain, Locale } from '../../types';

export enum BaseLocalizationNamespace {
  common = 'common',
  'limits_page' = 'limits_page',
  'password_reset' = 'password_reset',
  bonus = 'bonus',
  widgets = 'widgets',
  freshchat = 'freshchat',
}

export type LocalizationNamespace = keyof typeof BaseLocalizationNamespace;

export type LocalizationResponse = {
  [key: string]: string;
  namespace: LocalizationNamespace;
};

export type Localization = {
  [key: string]: string;
};

export type { Locale };

function serializeLocalizationResponse(
  locales: EntryCollection<LocalizationResponse>
): Localization {
  return locales.items.reduce((collection: Localization, item) => {
    collection[item.fields.key] = item.fields.text;
    return collection;
  }, {});
}

export default async function getLocalization(
  client: ContentfulClientApi,
  locale: Locale = 'de',
  namespace: LocalizationNamespace = 'common',
  ignoreDomain: Domain
): Promise<Localization> {
  try {
    const query = {
      content_type: 'i18nText',
      'fields.domain[nin]': ignoreDomain,
      'fields.namespace': namespace,
      locale,
      limit: '1000',
    };
    const res = await client.getEntries<LocalizationResponse>(query);
    return serializeLocalizationResponse(res);
  } catch (error) {
    console.error('Contentful Error:: getBonuses failed');
    throw error;
  }
}
